<div class="filter-dropdown p-2">
  <app-ls-search-input *ngIf="columnConfig?.type!=FILTER_TYPES.DATE"
    [initialValue]="searchText"
    (onSearch)="onSearch($event)"></app-ls-search-input>
  <app-ls-search-input *ngIf="columnConfig?.type===FILTER_TYPES.DATE" (onSearch)="onSearch($event)"
    [isDatePicker]="true"></app-ls-search-input>

  <div class="unique-list my-3" #filterScrollContainer>
    <div *ngIf="!isSearchActive && fullList.length > 0">
      <div *ngIf="filteredList.length > 0; else noData">
        <div class="form-check pb-2">
          <input class="form-check-input" type="checkbox" id="select-all" [checked]="areAllSelected()"
            (change)="toggleSelectAll($event)" />
          <label class="form-check-label" for="select-all">
            {{"Select All" | translate}}
          </label>
        </div>
        <div class="form-check" *ngFor="let item of filteredList; let last = last; let first = first" [ngClass]="{
                    'pb-0 pt-2': last,
                    'py-2': !last
                }">
          <input class="form-check-input" [ngClass]="columnConfig?.addClass?.join(' ')"
            type="checkbox" [(ngModel)]="item.checked" id="checkbox-{{item?.value}}"
            (change)="syncAndMergeCheckedItems(this.fullList,this.searchedResults,'full')" />
          <label class="form-check-label" for="checkbox-{{item?.value}}">
            <ng-container *ngTemplateOutlet="displayItem; context: { item: item }"></ng-container>
          </label>
        </div>
      </div>
    </div>
    <div *ngIf="isSearchActive">
      <div *ngIf="searchedResults.length > 0 && isSearchActive; else noData">
        <div class="form-check pb-2">
          <input class="form-check-input" type="checkbox" id="select-all" [checked]="areAllSearchedSelected()"
            (change)="toggleSelectAll($event)" />
          <label class="form-check-label" for="select-all">
            {{"Select All Search Results" | translate}}
          </label>
        </div>
        <div class="form-check" *ngFor="let item of searchedResults; let last = last; let first = first" [ngClass]="{
                    'pb-0 pt-2': last,
                    'py-2': !last
                }">
          <input class="form-check-input" type="checkbox" [(ngModel)]="item.checked" id="checkbox-{{item?.value}}"
            [ngClass]="columnConfig?.addClass?.join(' ')"
            (change)="syncAndMergeCheckedItems(this.fullList,this.searchedResults,'searched')" />
          <label class="form-check-label" for="checkbox-{{item?.value}}">
            <ng-container *ngTemplateOutlet="displayItem; context: { item: item }"></ng-container>
          </label>
        </div>
      </div>
    </div>

    <ng-template #noData>
      <div class="d-flex justify-content-center align-items-center text-muted h-100">
        {{"No items found" | translate}}
      </div>
    </ng-template>

    <ng-template #displayItem let-item="item">
      <ng-container [ngSwitch]="item?.type">
        <ng-container *ngSwitchCase="FILTER_TYPES.STRING">
          {{ item?.text }}
        </ng-container>

        <ng-container *ngSwitchCase="FILTER_TYPES.CURRENCY">
          {{ item?.isBlanked ? item?.text : (item?.text | currency) }}
        </ng-container>

        <ng-container *ngSwitchCase="FILTER_TYPES.DATE">
          {{ item?.isBlanked ? item?.text : (item?.text | date: DATE_FORMAT_MMDDYYYY) }}
        </ng-container>

        <ng-container *ngSwitchCase="FILTER_TYPES.PHONE">
          <ng-container *ngIf="item?.additionalText && !item?.isBlanked">
            {{ item?.additionalText }}<br>
          </ng-container>
          {{ item?.isBlanked ? item?.text : (item?.text | mask: US_PHONE_MASKING) }}
        </ng-container>
      </ng-container>
    </ng-template>

    <div
      appInfiniteScroll
      [root]="filterScrollContainer"
      [disabled]="isScrolled || currentPage >= totalPage"
      (reached)="onInfiniteScroll()"
    ></div>

  </div>

  <div class="d-flex justify-content-end align-items-center">
    <a href="javascript:;" class="text-underline export-link me-2" (click)="reset()">{{"Reset"|translate}}</a>&thinsp;
    <button class="btn btn-success me-2" (click)="onSave()"
      [disabled]="!isAnySelected()">{{"OK" | translate}}</button>
    <button class="btn btn-success" (click)="onCancel()">{{"Close" | translate}}</button>
  </div>
</div>